<div class="smooth-scrolling without-sub-header set-top">

  <!-- career detail start -->

  <section class="career-detail p-80">
    <div class="mx-1485">
      <div class="row">
        <div class="col-lg-3">
          <div class="main-title">
            <h3>Careers</h3>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="career-box">
            <span>At ecommerce, we’re on a mission to empower people to feel confident and beautiful in their own skin. We
              believe that everyone deserves access to high-quality, effective skincare products that truly work. And
              we’re looking for talented individuals who share our passion to join our team.</span>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="career-description">
            <span>Here are a few reasons to consider a career with us:</span>
            <ul>
              <li>Make an Impact: As a member of our team, you’ll play a critical role in helping us achieve our
                mission. Whether you’re in marketing, product development, or customer service, you’ll be helping people
                all over the world feel their best.</li>
              <li>Work with a Talented Team: We’re proud to have a team of passionate and talented individuals who are
                committed to excellence. We’re always looking for top talent to join our team and contribute to our
                success.</li>
              <li>Grow and Develop Your Career: At ecommerce, we’re committed to helping our team members grow and develop
                their careers. Whether you’re just starting out or looking to take the next step in your career, we’ll
                provide the support and resources you need to succeed.</li>
              <li>Enjoy a Positive and Supportive Culture: We believe in fostering a positive and supportive culture
                that empowers our team members to thrive. We’re committed to creating a safe and inclusive work
                environment where everyone feels valued and respected.</li>
            </ul>
            <span class="career-work">Want to work with us? We’d love to hear from you! Email your CV, along with a
              little intro
              about yourself at <a href="#">jobs@ecommerce.com</a> and we’ll get back to you.</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- career detail end -->
</div>
<!-- Footer START -->
<app-footer></app-footer>
<!-- Footer END -->